import { DocumentData, FirestoreDataConverter } from "firebase/firestore";
import { Post } from "../models/Post";

export const postConverter: FirestoreDataConverter<Post> = {
  toFirestore(post: Post): DocumentData {
    return post;
  },
  fromFirestore(snapshot, options): Post {
    const data = snapshot.data(options) as Post;
    const LAYOUT_ENGINE_CUTOFF_MS = Date.parse("2026-02-04T00:32:00Z");
    const inferredLayoutEngine: "fabric" | "remotion" =
      data.createdAt && data.createdAt >= LAYOUT_ENGINE_CUTOFF_MS
        ? "remotion"
        : "fabric";

    // On-the-fly migration from textOverlays to overlays
    if (data.mediaItems) {
      for (const mediaItem of data.mediaItems) {
        if (
          mediaItem.metadata &&
          (mediaItem.metadata as any).textOverlays &&
          (!mediaItem.metadata.overlays ||
            mediaItem.metadata.overlays.length === 0)
        ) {
          mediaItem.metadata.overlays = (
            mediaItem.metadata as any
          ).textOverlays.map((o: any) => ({
            ...o,
            type: "text",
          }));
        }

        if (mediaItem.metadata && !mediaItem.metadata.layoutEngine) {
          mediaItem.metadata.layoutEngine = inferredLayoutEngine;
        }
      }
    }

    return data;
  },
};
